// config/navbarButtons.js
const navbarButtons = [
  {
    label: "Home",
    path: "/",
    variant: "text",
  },
  {
    label: "About",
    path: "/about",
    variant: "text",
  },
  {
    label: "Contact Us",
    path: "/contact",
    variant: "contained",
    isSpecial: true,
  },
];

export default navbarButtons;
